// Disable rechtermuisklik op plaatjes om het moeilijker te maken ze te kopieren.
var images = document.getElementsByTagName('img');
for (const image of images) {
     image.addEventListener('contextmenu', function(e) {
         e.preventDefault();
     });
}
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
